import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IPermissionsResponse } from "../../features/Configurations/RoleManagement/interface";

export function useCategorizedPermissions() {
  return useQuery<IPermissionsResponse>({
    queryKey: ["categorizedPermissions"],
    queryFn: async () => {
      const response = await httpService.get<IPermissionsResponse>(
        API_CONFIG.path.categorizedPermissions
      );
      return response;
    },
  });
}
